import { post } from '../api';
import { askConfirm } from '../components/ask';
import { formatMoney } from '../money';

// "matched" is the server's word for a bill whose total agrees with what its visits pay.
export const BILL_STATUS: Record<string, string> = {
  received: 'To check',
  matched: 'Ready to pay',
  disputed: "Doesn't match",
  paid: 'Paid',
};
/** Ready to pay is the good news; a bill still to check is the one that wants a look. */
export const BILL_PILL: Record<string, string> = {
  received: 'pill warn',
  matched: 'pill info',
  disputed: 'pill bad',
  paid: 'pill ok',
};

interface Payable {
  id: number;
  contractor_name: string;
  invoice_number: string;
  total_ex_gst: string;
  gst_amount: string;
}

/** What the contractor is actually paid: the bill's total with its GST. */
export const billPaid = (b: Payable) =>
  (Math.round(Number(b.total_ex_gst) * 100) + Math.round(Number(b.gst_amount || 0) * 100)) / 100;

/**
 * Mark a bill paid after saying who gets how much. Paying is the one money step
 * here that can't be taken back in the bank, so it always asks. Resolves to
 * what to tell the office, or '' when they changed their mind.
 */
export async function payBill(b: Payable, disputed = false): Promise<string> {
  const amount = formatMoney(billPaid(b));
  const yes = await askConfirm({
    title: disputed ? `Accept ${b.contractor_name}'s total?` : `Mark ${b.invoice_number} paid?`,
    body: disputed
      ? `This bill doesn't match what its visits pay. Accepting it records ${b.invoice_number} as paid at ${amount} (including GST), as they billed it. It doesn't pay them: do that from your bank first.`
      : `Record that ${b.contractor_name} has been paid ${amount} (including GST).`,
    confirmLabel: disputed ? 'Accept and mark paid' : 'Mark paid',
    danger: disputed,
  });
  if (!yes) return '';
  await post(`/api/bills/${b.id}/paid`);
  return `${b.invoice_number} marked paid: ${amount} to ${b.contractor_name}.`;
}

/** Undo a "mark paid" made by mistake. */
export const unpayBill = (id: number) => post(`/api/bills/${id}/unpaid`);
